  import PhotoSwipeLightbox from 'https://cdnjs.cloudflare.com/ajax/libs/photoswipe/5.4.4/photoswipe-lightbox.esm.min.js';

const lightbox = new PhotoSwipeLightbox({
  gallery: '[id^="Slider-main-"]',
  children: 'a[itemprop="contentUrl"]',
  wheelToZoom: true,
  pswpModule: () => import('https://cdnjs.cloudflare.com/ajax/libs/photoswipe/5.4.4/photoswipe.esm.min.js'),
  allowPanToNext: false
});

lightbox.init();



const lightbox2 = new PhotoSwipeLightbox({
  gallery: '[id^="SwiperGalleryViewer-swiper-"]',
  children: 'a[itemprop="contentUrl"]',
  wheelToZoom: true,
  pswpModule: () => import('https://cdnjs.cloudflare.com/ajax/libs/photoswipe/5.4.4/photoswipe.esm.min.js'),
  allowPanToNext: false
});

lightbox2.init();


const lightbox3 = new PhotoSwipeLightbox({
  gallery: '[id^="ProductGalleryViewer-"]',
  children: 'a[itemprop="contentUrl"]',
  wheelToZoom: true,
  pswpModule: () => import('https://cdnjs.cloudflare.com/ajax/libs/photoswipe/5.4.4/photoswipe.esm.min.js'),
  allowPanToNext: false
});

lightbox3.init();